<template>
  <div>
		<div class="navbar">
			<div class="nav_wrapper margin">
				<h4 class="title">家长监护</h4>
			</div>
		</div>
			<div class="parent_continer">
				<div class="parent_custody">
					<div class="top"></div>
					<div class="tab">
						<ul class>
							<li @click="tab=1" :class="tab==1?'s':''">系统介绍</li>
							<li @click="tab=2" :class="tab==2?'s':''">服务流程</li>
							<li @click="tab=3" :class="tab==3?'s':''">常见问题</li>
							<li @click="tab=4" :class="tab==4?'s':''">进度查询</li>
						</ul>
					</div>
					<div class="jh_content" v-show="tab==1">
						<div class="cont_jxjs">
							<div class="introduce">
								<div class="i_left">
									“网络游戏未成年人家长监护工程”是一项由多家网络游戏企业共同发起并参与实施，由中华人民共和国文化部指导，旨在加强家长对未成年人参与网络游戏的监护，引导未成年人健康、绿色参与网络游戏，和谐家庭关系的社会性公益行动。       家长监护机制”是蜗牛在这一公益行动中，针对目前未成年人缺乏
									自控及自律能力，容易陷入沉迷；少数监护人缺少时间照顾孩子，不能及时监督孩子游戏时间的现状，而推出的一种可由家长实施监控，纠正部分未成年子女沉迷游戏的保护机制。
								</div>
								<div class="i_right">
									<img src="../../images/parentcust/yh_jhimg.png"/>
								</div>
							</div>
							<div class="detail_flow">
								<div class="flows rel">							
									<h4><span class="number">一</span>申请条件</h4>
									<p class="text">
										1、申请人需为被监护未成年人的法定监护人；<br/>
										2、申请人的被监护人年龄小于18周岁；<br/>
										3、申请人需为大陆公民，不含港、澳、台人士
									</p><br/>							
									<h4><span class="number">二</span>申请需要提交材料</h4>
									<p class="text">
										1、监护人信息表（包含监护人的身份证明复印件）；（<a href="http://xlhy-houtai.oss-cn-hangzhou.aliyuncs.com/jiazhangjianhu/%E9%99%84%E4%BB%B6%E4%B8%80%E7%9B%91%E6%8A%A4%E4%BA%BA%E4%BF%A1%E6%81%AF%E8%A1%A8%E6%98%8E%E4%B9%A6.doc">点击下载附件一</a>）<br/>
										2、被监护人信息表（包含被监护人所玩游戏相关信息及身份证明复印件）；（<a href="http://xlhy-houtai.oss-cn-hangzhou.aliyuncs.com/jiazhangjianhu/%E9%99%84%E4%BB%B6%E4%BA%8C%E8%A2%AB%E7%9B%91%E6%8A%A4%E4%BA%BA%E4%BF%A1%E6%81%AF%E8%A1%A8%E6%98%8E%E4%B9%A6.doc">点击下载附件二</a>）<br/>
										3、填写网络游戏未成年人家长监护申请书、保证书、授权书并手工签字（需下载，填写并打印，签字）；（<a href="http://xlhy-houtai.oss-cn-hangzhou.aliyuncs.com/jiazhangjianhu/%E9%99%84%E4%BB%B6%E4%B8%89%E5%AE%B6%E9%95%BF%E7%9B%91%E6%8A%A4%E7%94%B3%E8%AF%B7%E4%B9%A6.doc">点击下载附件三</a>）<br/>
										4、派出所/公安机关出示的监护关系证明书（非必要条件）。
									</p><br/>	
									<h4><span class="number">三</span>申请方式</h4>
									<h6 class="first">1.接待服务 <span class="little">监护人可以直接上门服务</span></h6>
									<div class="txt">接待服务时间：<span>早 10：00 —晚 7：30  全年无休</span></div>
									<div class="txt">接待服务地址：<span>北京朝阳区红军营南路汇中广场3层闲来互娱</span></div>
									<h6>2.传真服务 <span class="little">监护人可以通过传真发送相关信息，进行申请</span></h6>
									<div class="txt">服务传真：<span>010-655655658</span></div>	
									<h6>3.邮寄服务 <span class="little">监护人可以通过快递发送相关信息，进行申请 。</span></h6>
									<img src="../../images/parentcust/yh_youji.png"/><br/>
									<h4><span class="number">四</span>监督方式</h4>
									<h6 class="first">A. 屏蔽账号</h6>
									<p class="text lst">
										根据监护人意愿屏蔽相关游戏应用登陆
									</p>
									<h6>B.账号动态监控：</h6>
									<p class="text lst">
										登陆、修改密码等操作将发短信至监护人手机。<br/>
										（1）账号已经有认证手机的，将监护人手机替换为认证手机；<br/>
										（2）账号未认证手机，将监护人手机绑定成认证手机；2）账号未认证手机，将监护人手机绑定成认证手机；
									</p><br/>
									<h4><span class="number">五</span>其他要求</h4>
									<p class="text">
										1、申请人应提交较完备的申请材料，对未提供的信息要及时补充；可请熟知电脑、互联网、游戏的人员进行协助，以便提供详<br/>
										2、申请人应保证提交的信息真实有效；对于提供虚假信息或伪造证件，监护关系证明书追究法律责任的权利。
									</p><br/>
									<div class="dashed_line"></div>
								</div>
								<div class="others">
									<div class="load">
										<h6>快速下载</h6>
										<div class="docs">
											<span class="yh_icon_book"></span>附件一：监护人信息表明书
										</div>
										<div class="docs">
											<span class="yh_icon_book"></span>附件二：被监护人信息表明书
										</div>
										<div class="docs">
											<span class="yh_icon_book"></span>附件三：家长监护申请书
										</div>
										<a class="btn_load" href="http://xlhy-houtai.oss-cn-hangzhou.aliyuncs.com/jiazhangjianhu/jianhu.zip"><span class="icon_load"></span>打包下载</a>
									</div>
									<div class="load">
										<h6>24小时热线</h6>
										<div class="constract">
											<span class="key">服务热线</span>
											<span class="value">010-84937285</span>
										</div>
									</div>
								</div>
							</div>					
						</div>
					</div>
					<div class="jh_content" v-show="tab==2">
						<div class="cont_jxjs">
								<div class="detail_flow">
									<div class="flows">
										<h3 class="title">家长监护说明</h3>
										<p class="parent_txt">
											家长监护工程充分考虑家长的实际需求，当家长发现自己的孩子玩游戏过于沉迷的时候，由家长提供合法的监护人资质证明、游戏名称账号、以及家长对于限制强度的愿望等信息，可对处于孩子游戏沉迷状态的账号采取几种限制措施，解决未成年人沉迷网游的不良现象，如限制孩子每天玩游戏的时间区间和长度，也可以限制只有周末才可以游戏，或者完全禁止。
										</p>
										<h3 class="title">监护申请流程</h3>
										<img src="../../images/parentcust/yh_flow.png" align="right" style="width:519px;padding-right:30px;"/>
									</div>
									<div class="others">								
										<img class="img" src="../../images/parentcust/yh_jhimg.png"/>								
										<div class="load">
											<h6>快速下载</h6>
											<div class="docs">
												<span class="yh_icon_book"></span>附件一：监护人信息表明书
											</div>
											<div class="docs">
												<span class="yh_icon_book"></span>附件二：被监护人信息表明书
											</div>
											<div class="docs">
												<span class="yh_icon_book"></span>附件三：家长监护申请书
											</div>
											<a class="btn_load" href="http://xlhy-houtai.oss-cn-hangzhou.aliyuncs.com/jiazhangjianhu/jianhu.zip"><span class="icon_load"></span>打包下载</a>
										</div>
										<div class="load">
											<h6>24小时热线</h6>
											<div class="constract">
												<span class="key">服务热线</span>
												<span class="value">010-84937285</span>
											</div>
										</div>
                                    </div>	
								</div>				
						</div>
					</div>
					<div class="jh_content" v-show="tab==3">
						<div class="cont_jxjs">
								<div class="detail_flow">
									<div class="flows">
										<h3 class="title">常见解答</h3>
										<div class="question clearfix">
											<span class="larger">Q：</span><span class="smaller">可以通过什么渠道申请家长监督未成年人账号？</span>
										</div>								
										<div class="answer clearfix">
											<span class="larger">A：</span><span class="smaller">目前您可以通过邮寄、上门和传真方式进行申请。</span>
										</div>																
										<div class="question clearfix">
											<span class="larger">Q：</span><span class="smaller">什么时间可以申请？</span>
										</div>								
										<div class="answer clearfix">
											<span class="larger">A：</span>
											<span class="smaller">邮寄服务：7*24小时<br/>
												接待服务：7*8小时，全年无休<br/>
												传真服务：7*24小时，24小时接受申请。</span>
										</div>								
										<div class="question clearfix">
											<span class="larger">Q：</span><span class="smaller">申请监督未成年人账号方式有哪些？</span>
										</div>								
										<div class="answer clearfix">
											<span class="larger">A：</span>
											<span class="smaller">所有账号纳入防沉迷系统；以下方式可以任选：1、屏蔽账号（根据申请人意愿屏蔽个
											别游戏应用）；2、账号动态监控</span>
										</div>	
										<div class="question clearfix">
											<span class="larger">Q：</span><span class="smaller">申请监督的账号有什么要求？</span>
										</div>								
										<div class="answer clearfix">
											<span class="larger">A：</span>
											<span class="smaller">账号所属人必须未满18周岁。</span>
										</div>
										<div class="question clearfix">
											<span class="larger">Q：</span><span class="smaller">申请人有什么要求？</span>
										</div>								
										<div class="answer clearfix">
											<span class="larger">A：</span>
											<span class="smaller">1、申请人应提交较完备的申请材料，对未提供的信息要及时补充；可请熟知电脑、互联网、游戏的人员进行协助，以便提 供详实资料；<br/>2、申请人应保证提交的信息真实有效；对于提供虚假信息或伪造证件，受理公司将保留进一步追究法律责任的权利。</span>
										</div>																
										<div class="question clearfix">
											<span class="larger">Q：</span><span class="smaller">申请监督未成年人账号需要提供什么？</span>
										</div>								
										<div class="answer clearfix">
											<span class="larger">A：</span>
											<span class="smaller">您需要提供监护人身份证复印件、账号所属人身份证复印件以及户口本复印件、如双方户籍不在一起，需要提供公安机关 监护证明、被监护人信息表、监护人信息表、家长监护申请书（申请书、保证书、授权书，需要下载，填写，并打印，手 工签字）。</span>
										</div>																
										<div class="question clearfix">
											<span class="larger">Q：</span><span class="smaller">申请人提交申请后，多久可以处理完成？</span>
										</div>								
										<div class="answer clearfix">
											<span class="larger">A：</span>
											<span class="smaller">我们将以最快的速度进行核实处理，由于您提供的材料不同，任何步骤有疑问，我们都会与您联系。</span>
										</div>																
										<div class="question clearfix">
											<span class="larger">Q：</span><span class="smaller">申请成功后，如果需要取消监督如何操作？</span>
										</div>								
										<div class="answer clearfix">
											<span class="larger">A：</span>
											<span class="smaller">1、您可以通过上门或传真方式提供申请监督时的相关信息，申请解除监督；<br/>
											2、被监护账号所属人年满18周岁可提供申请监督时的相关信息进行申请结束监督；</span>
										</div>																
									</div>
									<div class="others">								
										<img class="img" src="../../images/parentcust/yh_jhimg.png"/>								
										<div class="load">
											<h6>快速下载</h6>
											<div class="docs">
												<span class="yh_icon_book"></span>附件一：监护人信息表明书
											</div>
											<div class="docs">
												<span class="yh_icon_book"></span>附件二：被监护人信息表明书
											</div>
											<div class="docs">
												<span class="yh_icon_book"></span>附件三：家长监护申请书
											</div>
											<a class="btn_load" href="http://xlhy-houtai.oss-cn-hangzhou.aliyuncs.com/jiazhangjianhu/jianhu.zip"><span class="icon_load"></span>打包下载</a>
										</div>
										<div class="load">
											<h6>24小时热线</h6>
											<div class="constract">
												<span class="key">服务热线</span>
												<span class="value">010-84937285</span>
											</div>
										</div>
                                    </div>	
								</div>
						</div>
					</div>
					<div class="jh_content" v-show="tab==4">
						<div class="cont_jxjs">
							<div class="introduce">
								<div class="i_left">
									“网络游戏未成年人家长监护工程”是一项由多家网络游戏企业共同发起并参与实施，由中华人民共和国文化部指导，旨在加强家长对未成年人参与网络游戏的监护，引导未成年人健康、绿色参与网络游戏，和谐家庭关系的社会性公益行动。       家长监护机制”是蜗牛在这一公益行动中，针对目前未成年人缺乏
									自控及自律能力，容易陷入沉迷；少数监护人缺少时间照顾孩子，不能及时监督孩子游戏时间的现状，而推出的一种可由家长实施监控，纠正部分未成年子女沉迷游戏的保护机制。
								</div>
								<div class="i_right">
									<img src="../../images/parentcust/yh_jhimg.png"/>
								</div>
							</div>
							<div class="detail_flow">
                                <div class="flows">
                                    <div class="inputs">
                                        输入身份证号<input  v-model="cardno" type="text" maxlength="18"/>
                                        <span class="btn_find" @click="searchcardno"><i class="icon_find"></i>查询</span>
                                    </div>
                                    <div class="error_tips" id="error_tips"></div>
                                </div>
                                <div class="others">															
                                    <div class="load four">
                                        <h6>快速下载</h6>
                                        <div class="docs">
                                            <span class="yh_icon_book"></span>附件一：监护人信息表明书
                                        </div>
                                        <div class="docs">
                                            <span class="yh_icon_book"></span>附件二：被监护人信息表明书
                                        </div>
                                        <div class="docs">
                                            <span class="yh_icon_book"></span>附件三：家长监护申请书
                                        </div>
                                        <a class="btn_load" href="http://xlhy-houtai.oss-cn-hangzhou.aliyuncs.com/jiazhangjianhu/jianhu.zip"><span class="icon_load"></span>打包下载</a>
                                    </div>
                                </div>	
							</div>
							<div class="detail_flow">
                                <div class="flows" style="border:0px;"></div>															
                                <div class="others">															
                                    <div class="load four">
                                        <h6>24小时热线</h6>
                                        <div class="constract">
                                            <span class="key">服务热线</span>
                                            <span class="value">010-84937285</span>
                                        </div>
                                    </div>
                                </div>	
							</div>
						</div>
					</div>		
				</div>
                <!--常见问题弹窗-->
                <div class="alert_window" v-show="tab==3&&alert">
                    <div class="common_question">
                        <h6 class="title">未成年人健康参与网络游戏提示<span class="close" @click="closealert"></span></h6>
                        <div class="content-wrap">
                            <p class="notice">随着网络在青少年中的普及，未成年人接触网络游戏已经成为普遍现象。为保护未成年人健康参与游戏，在政府进一步加强行业管理的前提下，家长也应当加强监护引导。为此，我们为未成年人参与网络游戏提供以下意见：<br/><br/>		  	
                            一、主动控制游戏时间。游戏只是学习、生活的调剂，要积极参与线下的各类活动，并让父母了解自己在网络游戏中的行为和体验。<br/>		
                            二、不参与可能耗费较多时间的游戏设置。不玩大型角色扮演类游戏，不玩有PK类设置的游戏。在校学生每周玩游戏不超过2小时，每月在游戏中的花费不超过10元。<br/>
                            三、不要将游戏当作精神寄托。尤其在现实生活中遇到压力和挫折时，应多与家人朋友交流倾诉，不要只依靠游戏来缓解压力。<br/>
                            四、养成积极健康的游戏心态。克服攀比、炫耀、仇恨和报复等心理，避免形成欺凌弱小、抢劫他人等不良网络行为习惯。<br/>
                            五、注意保护个人信息。包括个人家庭、朋友身份信息，家庭、学校、单位地址，电话号码等，防范网络陷阱和网络犯罪。<br/>
                            </p>	
                            <p class="date">二〇一〇年五月二十八日</p>
                            <p class="company_txt">
                                文化部网络游戏内容审查专家委员会<br/>
                                中国教育学会中小学信息技术教育委员会<br/>
                                中国青少年网络协会<br/>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
  </div>
</template>

<script>
export default {	
    data(){
        return{
            tab:1,
            alert:true,
            cardno:''
        }
    },		
    methods:{
        closealert:function(){
            this.alert=false;
        },
        searchcardno:function(){
            if(this.cardno ==''){
                $("#error_tips").html("请输入身份证号！");
                return;
            }				
            if(/^\d{17}(\d|x|X)$/i.test(this.cardno)){
                $("#error_tips").addClass("s");
                $("#error_tips").html("正在审核中...");
            }else{
                $("#error_tips").removeClass("s");
                $("#error_tips").html("输入的身份证号码有误!");
            }
        }
    }
}
</script>

<style scoped lang="scss" >
	.navbar{
		position: relative;
		width: 100%;
		min-width: 1000px;
		height:75px;
		color: #fff;
		background-color:#303030;
		margin-top: -5px;
	.nav_wrapper{
		position:relative;
		height:100%;
		background: url('../../images/navbar.png') no-repeat center center;
	.title{
		position:relative;
		padding:20px 0px 20px 20px;
		font-weight:bolder;
		font-size:26px;
		color:#fff;
	}
	.title:before{
		position: absolute;
		top: 26px;
		left:0px;
		bottom: 1px;
		display: inline-block;
		content: '';
		height:24px;
		content:'';
		border-left:4px solid #ffdb17;
		margin-right:28px;
	}
	}
	}
			.parent_continer{
				width:100%;
				min-width:1000px;
				position:relative;								
			}
			.parent_custody{				
				width: 1000px;
				height: auto;
				overflow: hidden;
				margin: 0px auto;
				padding-bottom: 100px;
			}
			.parent_custody .top{
				width: 1000px;
				height: 239px;
				background: url('../../images/parentcust/yh_bg.png') no-repeat center top;
			}
			.parent_custody .tab ul{
				width:100%;	
				height:50px;	
				display: flex;	
				display: -webkit-flex;
			}
			.parent_custody .tab ul>li{
				position:relative;
				display:inline-block;
				flex:1;
				padding:15px 0px;
				text-align: center;								
				font-size:16px;
				color:#fff;
				cursor:pointer;				
				background: -webkit-linear-gradient(top, #65b81c, #279225);
				background: -o-linear-gradient(top, #65b81c, #279225);
				background: -moz-linear-gradient(top, #65b81c, #279225);
				background: linear-gradient(top,#65b81c, #279225);
			}
			.parent_custody .tab ul>li:after{
				position:absolute;
				display:block;
				content:'';
				width:1px;
				top:15px;
				bottom:15px;
				border-right: 1px solid #22821a;
			}
			.parent_custody .tab ul>li:first-child:after{
				position:static;
			}
			.parent_custody .tab ul>li.s:before{
				display: block;
				position:absolute;
				top:50%;
				margin-top:-5px;
				left:32%;
				content:'';
				width:5px;
				height:10px;
				background: url(../../images/parentcust/yh_jiantou.png) no-repeat center center;	
			}
			.jh_content{
				margin-top:20px;
			}
			/*系统介绍*/
			.cont_jxjs .introduce{
				display: flex;
			}
			.cont_jxjs .introduce .i_left{
				flex:1;
				border:1px solid #bae19a;
				padding:28px;
				line-height:25px;
				font-size:14px;				
			}
			.cont_jxjs .introduce .i_right img{
				width:152px;
				height:184px;
				margin:0 70px;
			}
			.cont_jxjs .detail_flow{
				display: flex;
				margin-top:20px;
			}
			.cont_jxjs .detail_flow .flows{				
				flex:1;
				border:1px solid #bae19a;
				padding:28px;				
			}
			.cont_jxjs .detail_flow .flows.rel{
				position: relative;
			}
			.cont_jxjs .detail_flow .flows .dashed_line{
				position: absolute;
				top:65px;
				left:48px;
				border-left:1px;
				height:1200px;
				border-style:dashed; 	
                border-color:#46a521;
                z-index: 1;
			}
			.cont_jxjs .detail_flow .flows h4{
				position: absolute;
				font-weight:bolder;
				font-size:18px;
				color:#3d9f22;
				z-index: 5;
			}
			.cont_jxjs .detail_flow .flows h4 .number{
				display: inline-block;
				width:40px;
				height:40px;
				margin-right:15px;
				background: -webkit-linear-gradient(top, #65b81c, #289325);
				background: -o-linear-gradient(top, #65b81c, #289325);
				background: -moz-linear-gradient(top, #65b81c, #289325);
				background: linear-gradient(top,#65b81c, #279225);
				border-radius: 50%;
				line-height: 40px;
				text-align: center;
				font-weight:bolder;
				font-size:18px;
				color:#fff;
			}
			.cont_jxjs .detail_flow .flows .text{	
				margin-top:35px;			
				font-size:14px;
				line-height: 30px;
				padding-left:55px;
			}
			.cont_jxjs .detail_flow .flows .text.lst{
				margin-top:0px;	
			}
			.cont_jxjs .detail_flow .flows .text a{
				color:#3d9f22;
			}
			.cont_jxjs .detail_flow .flows h6.first{
				margin-top:35px;
			}
			.cont_jxjs .detail_flow .flows h6{				
				line-height: 40px;
				padding-left:55px;
				font-weight:bolder;
				font-size:18px;
				color: #3d9f22;
			}
			.cont_jxjs .detail_flow .flows h6 .little{
				font-size:14px;
				color: #3d9f22;
				font-weight:normal;
			}
			/**服务流程*/
			.cont_jxjs .detail_flow .flows .title{
				width:140px;
				height:40px;
				line-height:40px;
				text-align: center;
				background: -webkit-linear-gradient(top, #65b81c, #289325);
				background: -o-linear-gradient(top, #65b81c, #289325);
				background: -moz-linear-gradient(top, #65b81c, #289325);
				background: linear-gradient(top,#65b81c, #279225);
				border-radius: 25px;	
				font-weight: bold;
				font-size:18px;
				color:#fff;			
			}
			/*进度查询*/
			.cont_jxjs .detail_flow .flows .inputs{
				padding-top:72px;
				font-size:14px;
				text-align: center;				
			}
			.error_tips{
				text-align: center;
				font-size:14px;
				color:#63b71d;
				line-height:50px;
				padding-right:30px;
			}
			.error_tips.s:before{
				content: '';
				display: inline-block;
				width:20px;
				height:20px;
				background: url(../../images/parentcust/yh_icon_shenhe.png) no-repeat center center;
				vertical-align: middle;				
			}
			.cont_jxjs .detail_flow .flows .inputs input{
				border:1px solid #bae19a;
				border-radius:5px;
				line-height: 40px;
				font-size:18px;
				padding:0px 10px;
				color:#666;
				font-weight: bolder;
				margin:0px 10px;
				vertical-align: middle;
			}
			.cont_jxjs .detail_flow .flows .inputs .btn_find{
				display: inline-block;
				width: 120px;
				height: 42px;
				border-radius: 5px;
				background: -webkit-linear-gradient(top, #65b81c, #269225);
				background: -o-linear-gradient(top, #65b81c, #269225);
				background: -moz-linear-gradient(top, #65b81c, #269225);
				background: linear-gradient(top,#65b81c, #269225);
				line-height: 42px;
				text-align: center;
				font-size: 18px;
				color: #fff;
				vertical-align: middle;
				cursor:pointer;
			}
			.cont_jxjs .detail_flow .flows .inputs .btn_find .icon_find{
				display: inline-block;
				width: 18px;
				height: 18px;
				margin-right: 5px;
				background: url(../../images/parentcust/yh_icon_find.png) no-repeat;
				vertical-align: middle;
			}
			/*常见问题*/
			.cont_jxjs .detail_flow .flows .question{
                padding:15px 0 15px 20px;
                display: -webkit-flex; 
                display: flex;
                align-items:center;
			}
			.cont_jxjs .detail_flow .flows .question .larger{
		
				display: block;
				font-size:30px;
				color:#309823;
			}
			.cont_jxjs .detail_flow .flows .question .smaller{
				flex:1;
				margin-top:10px;
				display: block;
				font-size:18px;
				color:#309823;		
			}
			.cont_jxjs .detail_flow .flows .answer{
				display: -webkit-flex;
                display: flex;
                align-items:center;
                padding:8px 0 8px 20px;
                background-color: #f8ffe6;			  
			}	
			.cont_jxjs .detail_flow .flows .answer .larger{
				display: block;
				font-size:30px;    
			}
			.cont_jxjs .detail_flow .flows .answer .smaller{
				flex:1;
				margin-top:10px;
				display: block;
				font-size:14px;					
			}	
			.cont_jxjs .detail_flow .flows .parent_txt{
				line-height: 25px;
                font-size: 14px;
                margin: 10px 0 28px;
			}
			/*.cont_jxjs .detail_flow .flows .flow_img{
				width: 519px;
				height: 641px;
				background: url(../../images/parentcust/yh_flow.png) no-repeat right center;				
			}*/
			.cont_jxjs .detail_flow .txt{
				line-height: 30px;
				padding-left:60px;
				font-weight:bolder;
				font-size:14px;		
				color:#666666;
			}		
			.cont_jxjs .detail_flow .txt span{
				font-weight:normal;
			}
			.cont_jxjs .detail_flow  img{
				display: block;
				margin:10px 0;
				width:586px;
				padding-left:55px;
			}
			.cont_jxjs .detail_flow .others{
				width:252px;
				margin:0px 20px;
			}
			.cont_jxjs .detail_flow .others .load{
				margin-bottom: 20px;
				border:1px solid #bae19a;
			}
			.cont_jxjs .detail_flow .others .load.four{
				margin-bottom: 0px;
			}
			.cont_jxjs .detail_flow .others  .img{
				width:152px;
				height:184px;
			}
			.cont_jxjs .detail_flow .others .load h6{
				border-top:5px solid #63b71d;
				border-bottom:1px solid #ccebd1;
				background-color: #e6ffea;
				padding-left:15px;
				margin-bottom:10px;
				line-height: 40px;
				font-weight: bold;
				font-size:16px;
				color:#63b71d;				
			}
			.cont_jxjs .detail_flow .others .load .constract{
				padding-bottom:15px;
			}
			.cont_jxjs .detail_flow .others .load .constract span{
				display: block;
				padding-left:14px;
			}
			.cont_jxjs .detail_flow .others .load .constract .key{
				font-size:14px;
				line-height: 25px;
			}
			.cont_jxjs .detail_flow .others .load .constract .value{
				line-height: 40px;
				font-weight:bolder;
				color:#77b373;
				font-size:24px;
			}
			.cont_jxjs .detail_flow .others .load .docs{
				padding-left:15px;
				font-size:14px;
				color:#666;
				line-height:28px;
			}
			.cont_jxjs .detail_flow .others .load .docs .yh_icon_book{
				display: inline-block;
				margin-right:10px;
				width:12px;
				height:13px;
				background: url(../../images/parentcust/yh_icon_book.png) no-repeat center center;	
			}
			.cont_jxjs .detail_flow .others .load  .btn_load{
				margin: 20px auto 30px;
				display: block;
				width:180px;
				height:50px;
				border-radius:5px;
				background: -webkit-linear-gradient(top, #65b81c, #269225);
				background: -o-linear-gradient(top, #65b81c, #269225);
				background: -moz-linear-gradient(top, #65b81c, #269225);
				background: linear-gradient(top,#65b81c, #269225);	
				line-height: 50px;
				text-align: center;
				font-size:18px;
				color:#fff;
				vertical-align: middle;	
			}
			.cont_jxjs .detail_flow .others .load  .btn_load .icon_load{
				display: inline-block;
				width:16px;
				height:23px;
				margin-right:5px;
				background: url(../../images/parentcust/yh_icon_load.png) no-repeat;
				vertical-align: middle;	
				
			}
			/**常见问题弹窗*/
			.alert_window{
				width:100%;
				height:100%;
				position: absolute;
				top:0px;
				left:0;
				bottom:0;
				right:0;
				background-color:rgba(0,0,0,0.4);
			}
			.alert_window .common_question{
				position: absolute;
                -ms-transform: translate(-50%, -50%);
                -webkit-transform: translate(-50%, -50%);
                -moz-transform: translate(-50%, -50%);
                transform: translate(-50%, -50%);
                left: 50%;
                top: 50%;				
				width:800px;
				background-color:#fff;
			}
			.alert_window .common_question .title{
				position: relative;	
				line-height:40px;
				text-align: center;		
				background: -webkit-linear-gradient(top, #65b81c, #269225);
				background: -o-linear-gradient(top, #65b81c, #269225);
				background: -moz-linear-gradient(top, #65b81c, #269225);
				background: linear-gradient(top,#65b81c, #269225);
				font-size:16px;
				color:#fff;				
			}
			.alert_window .common_question .title .close{
				display: block;
				position: absolute;
				top:50%;
				margin-top:-12px;
				right:10px;
				width:24px;
				height:24px;
				background: url(../../images/parentcust/yh_icon_close.png) no-repeat;
				cursor:pointer;
			}
			.alert_window .common_question .content-wrap{
				padding:30px;
				background-color:#fff;
			}
			.alert_window .common_question .content-wrap .notice{
				line-height:25px;
				font-size:14px;
				text-indent:25px;
			}
			.alert_window .common_question .content-wrap .date{
				line-height:45px;
				text-align: right;
			}
			.alert_window .common_question .content-wrap .company_txt{
				line-height:30px;
				font-weight:bold;
				text-align: right;
			}
</style>
